// this is similiar to bigquote slider
document.addEventListener('DOMContentLoaded', () => {
   const businesscard = document.querySelectorAll('.module_businesscard');

    businesscard.forEach(businesscardSlider => {
        let num = 1;
        let swiper; // Variable für Swiper-Instanz

        const slider = businesscardSlider.querySelector('.swiper');
        const paginationMobile = businesscardSlider.querySelector('.swiper-pagination.swiper-pagination-mobile');
        const paginationDesktop = businesscardSlider.querySelector('.swiper-pagination.swiper-pagination-desktop');
        const nextButton = businesscardSlider.querySelector('.swiper-button-desktop.swiper-button-next');
        const nextButtonMobile = businesscardSlider.querySelector('.swiper-button-mobile.swiper-button-next');
        const prevButton = businesscardSlider.querySelector('.swiper-button-desktop.swiper-button-prev');
        const prevButtonMobile = businesscardSlider.querySelector('.swiper-button-mobile.swiper-button-prev');

        // Funktion zur Swiper-Initialisierung basierend auf der Bildschirmbreite
        function initSwiper() {
            // Falls Swiper bereits existiert, zerstören und neu erstellen
            if (swiper) swiper.destroy(true, true);

            const isDesktop = window.innerWidth >= 768;
            const paginationElement = isDesktop ? paginationDesktop : paginationMobile;
            const nextButtonEL = isDesktop ? nextButton : nextButtonMobile;
            const prevButtonEL = isDesktop ? prevButton : prevButtonMobile;

            const slides = slider.querySelectorAll('.swiper-slide');
            const useDynamicBullets = slides.length > 5;
console.log(nextButtonEL)
            swiper = new Swiper(slider, {
                slidesPerView: 1,
                spaceBetween: 16,
                loop: false,
                pagination: {
                    el: paginationElement, // Dynamische Auswahl des Pagination-Elements
                    clickable: true,
                    dynamicBullets: useDynamicBullets,
                },
                navigation: {
                    nextEl: nextButtonEL,
                    prevEl: prevButtonEL,
                },
                breakpoints: {
                    768: {
                        slidesPerView: 1.7,
                        spaceBetween: 40,
                        centeredSlides: true,
                    }
                }
            });

            // SlideChange Event, um Inhalte zu ändern
            swiper.on('slideChange', () => {
                const bodyText = businesscardSlider.querySelector('.businesscard-body');
                const newBodyText = businesscardSlider.querySelector('.hiddenSlideContent-' + swiper.activeIndex).innerHTML;
                bodyText.innerHTML = newBodyText;
                num = swiper.activeIndex + 1;
            });
        }

        // Initial Swiper starten
        initSwiper();

        // Neu initialisieren, wenn sich die Fenstergröße ändert
        window.addEventListener('resize', initSwiper);
    });
});
